import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { ChangeEvent } from "react";

import { ModelState } from "../../interfaces/modelState";
import { Tooltip } from "../tooltip/Tooltip";
import { hasValidationMessage } from "../validationMessage/hasValidationMessage";
import { ValidationMessage } from "../validationMessage/ValidationMessage";
import useFieldData from "./useFieldData";
import useFieldName from "./useFieldName";

export interface SelectOption<T extends string> {
  value: string;
  key: T;
}

interface Props<T extends string> {
  fieldData: Record<string, Field<string>>;
  name: string;
  fieldName?: string;
  modelState?: ModelState | null;
  setModelState?: (modelState: ModelState) => void;
  value?: T;
  id?: string;
  onChange?: (value: T) => void;
  propertyName: string;
  options: SelectOption<T>[];
  hideDefaultSelection?: boolean;
  disabled?: boolean;
}

export function SelectionListInput<T extends string>(props: Props<T>) {
  const options = props.options || [];
  const { name, fieldName } = useFieldName(props.name, props.fieldName);
  const { heading, tooltip } = useFieldData(props.fieldData, name);
  const defaultSelectionText = "Maak een keuze";
  const value = props.value;

  const id = props.id || fieldName;

  const onFieldChange = (e: ChangeEvent<HTMLSelectElement>) => {
    if (props.onChange) {
      props.onChange(e.target.value as T);
    }
  };

  return (
    <>
      <div className="form-row">
        <div className="form-item">
          <div className="form-input">
            {heading.value && (
              <div className="form-label">
                <label htmlFor={id}>{heading.value}</label>
                <Tooltip fieldName={fieldName} value={tooltip.value} />
              </div>
            )}
            <div className="select">
              <select id={id} onChange={onFieldChange} value={value} disabled={props.disabled}>
                {!props.hideDefaultSelection && <option>{defaultSelectionText}</option>}
                {options.map((option, key) => {
                  return (
                    <option key={key} value={option.key}>
                      {option.value}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
      </div>

      {hasValidationMessage(props.modelState, props.propertyName) && (
        <div className="form-row">
          <ValidationMessage modelState={props.modelState} property={props.propertyName} />
        </div>
      )}
    </>
  );
}
